


































































































































































































































































































import axios from 'axios';
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import MediaDownloadPDFItem from './MediaDownloadPDFItem.vue';
import MediaDownloadImageItem from './MediaDownloadImageItem.vue';
import MediaDownloadVideoItem from './MediaDownloadVideoItem.vue';
import { DownloadImageResponse, DownloadImage, ResourceItem } from '@/models/DownloadImage';
import http from '@/services/Http';
import GenericSearch from '../Blocks/BookMeetingFlow/GenericSearch.vue';
@Component({
    components: {
        MediaDownloadPDFItem,
        MediaDownloadImageItem,
        MediaDownloadVideoItem,
        GenericSearch
    }
})
// @ts-ignore
export default class MediaDownloadList extends Vue {
    protected data!: DownloadImageResponse;
    protected toogleFilterMobile: boolean = false;
    protected slim: boolean = false;
    protected filterCategory: string[] = ['all', 'inspiration', 'product', 'frontmake', 'measurement', 'wirepicture'];
    protected filterProductType: string[] = ['all', 'kitchen', 'bath', 'storage'];
    protected filterProductSerie!: ResourceItem[];
    // protected filterResourceBrand!: ResourceItem[];
    protected filterProductSupplier!: ResourceItem[];
    protected searchText: string = '';
    protected searchLink: string = '';
    protected searchLinkNextPage: string = '';
    protected page: string = '';

    constructor() {
        super();
        this.data = JSON.parse(this.$attrs['data-content']);
        // this.filterResourceBrand = this.data.ResourceBrands;
        this.filterProductSerie = this.data.ResourceSeries;
        this.filterProductSupplier = this.data.ResourceSuppliers;
        this.slim = (this.$attrs['data-slim'] || '').toLowerCase() === 'true';
        this.$attrs['data-content'] = '';
        console.log(this.data);
    }

    private trigger() {
        window.location.href = this.search(1);
    }

    private toggleFilter(e: any) {
        const filter = e.currentTarget;

        if (!filter.classList.contains('open')) {
            this.closeFilters();
            filter.classList.add('open');
        } else if (filter.classList.contains('open') && e.srcElement.classList.contains('toggle-arrow')) {
            this.closeFilters();
        }
    }

    private showClearFilter(): boolean {
        if (
            (this.data.SearchCategory != null && this.data.SearchCategory != '' && this.data.SearchCategory != 'all') ||
            (this.data.SearchProductType != null &&
                this.data.SearchProductType != '' &&
                this.data.SearchProductType != 'all') ||
            (this.data.SearchBrand != null && this.data.SearchBrand != '' && this.data.SearchBrand != 'all') ||
            (this.data.SearchProductSerie != null && this.data.SearchProductSerie != '' && this.data.SearchProductSerie != 'all') ||
            (this.data.SearchProductSupplier != null && this.data.SearchProductSupplier != '' && this.data.SearchProductSupplier != 'all')
        ) {
            return true;
        }
        return false;
    }

    private clearFilter() {
        this.data.SearchCategory = this.filterCategory[0];
        this.data.SearchProductType = this.filterProductType[0];
        // this.data.SearchBrand = this.filterResourceBrand[0].Key;
        this.data.SearchProductSerie = this.filterProductSerie[0].Key;
        this.data.SearchProductSupplier = this.filterProductSupplier[0].Key;
        this.trigger();
    }

    private search(page: number): string {
        // console.log('search', this.$route);

        return (
            this.$route.path +
            '?cat=' +
            this.notNull(this.data.SearchCategory) +
            '&type=' +
            this.notNull(this.data.SearchProductType) +
            '&text=' +
            this.notNull(this.data.SearchText) +
            // '&brand=' +
            // this.notNull(this.data.SearchBrand) +
            '&serie=' +
            this.notNull(this.data.SearchProductSerie) +
            '&supplier=' +
            this.notNull(this.data.SearchProductSupplier) +
            '&page=' +
            page
        );
    }

    private notNull(text: string) {
        if (text == null) {
            return '';
        }

        return text;
    }

    // private updateSearchtext() {
    //     // console.log(this.data.SearchText);
    //     this.data.SearchText = this.searchText;
    //     this.searchText = query;
    //     this.data.SearchText = query;
    // }
    private updateSearchtext(query: string) {
        console.log('updateSearchtext', query);
        this.searchText = query;
        this.data.SearchText = query;
    }
    
    private clearSearch() {
        window.location.href =
            this.$route.path +
            '?cat=' + this.notNull(this.data.SearchCategory) +
            '&type=' + this.notNull(this.data.SearchProductType) +
            // '&brand=' + this.notNull(this.data.SearchBrand) +
            '&serie=' + this.notNull(this.data.SearchProductSerie) +
            '&supplier=' + this.notNull(this.data.SearchProductSupplier) +
            '&page=1';
    }
    
    private closeFilters() {
        const filters = document.querySelectorAll('.filter-item');
        filters.forEach((filter: any) => {
            filter.classList.remove('open');
        });
    }

    // private selectedFilter(option: string): boolean {
    //     // console.log('select', option, this.data.SearchCategory);
    //     if (this.data.SearchCategory == option) {
    //         return true;
    //     }
    //     return false;
    // }

    // private selectedFilter2(option: string): boolean {
    //     // console.log('select', option, this.data.SearchProductType);
    //     if (this.data.SearchProductType == option) {
    //         return true;
    //     }
    //     return false;
    // }

    // private selectedFilter3(option: string): boolean {
    //     // console.log('select', option, this.data.SearchProductType);
    //     if (this.data.SearchBrand == option) {
    //         return true;
    //     }
    //     return false;
    // }

    // private getSelectedFilter3(option: string): string {
    //     // this.data.ResourceBrands.find(i => i.Key == option)
    //     const selected = this.filterResourceBrand.find(i => i.Key == option);

    //     if (selected != undefined && selected != null) {
    //         return selected.Name;
    //     }

    //     return '';
    // }

    private getSelectedFilter4(option: string): string {
        // this.data.ResourceSeries.find(i => i.Key == option)
        const selected = this.filterProductSerie.find(i => i.Key == option);

        if (selected != undefined && selected != null) {
            return selected.Name;
        }

        return '';
    }

    private getSelectedFilter5(option: string): string {
        // this.data.ResourceSuppliers.find(i => i.Key == option)
        const selected = this.filterProductSupplier.find(i => i.Key == option);

        if (selected != undefined && selected != null) {
            return selected.Name;
        }

        return '';
    }

    private selectFilter(option: string) {
        this.data.SearchCategory = option;
        this.trigger();
    }

    private selectFilter2(option: string) {
        this.data.SearchProductType = option;
        this.trigger();
    }

    // private selectFilter3(option: string) {
    //     this.data.SearchBrand = option;
    //     this.trigger();
    // }

    private selectFilter4(option: string) {
        this.data.SearchProductSerie = option;
        this.trigger();
    }

    private selectFilter5(option: string) {
        this.data.SearchProductSupplier = option;
        this.trigger();
    }
}
